export class RandomUtils {

    public static generateUUID(): string {
        let dt = new Date().getTime();
        /* tslint:disable:no-bitwise */
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
            let r = (dt + Math.random() * 16) % 16 | 0;
            dt = Math.floor(dt / 16);
            return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        });
        /* tslint:enable:no-bitwise */
    }


    public static generateRandomString(length: number): string {
        let charSet ='ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var randomString = '';
        for (var i = 0; i < length; i++) {
            var randomPoz = Math.floor(Math.random() * charSet.length);
            randomString += charSet.substring(randomPoz,randomPoz+1);
        }
        return randomString;
    }

    public static addCommasToNumber(value){
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    }

    /**
     * Round value to exactly 2 decimal places
     * Examples: 22345.234 -> 22345.23, 22345.236 -> 22345.24, 0.014 -> 0.01, 0.016 -> 0.02
     */
    public static roundUp(value){
        if (value === null || value === undefined || isNaN(value)) {
            return value;
        }
        return Math.round(value * 100) / 100;
    }
    
    /**
     * Format value to exactly 2 decimal places (always shows 2 decimals)
     * Examples: 22345.234 -> 22345.23, 22345.236 -> 22345.24, 0.014 -> 0.01, 100 -> 100.00
     */
    public static formatToTwoDecimals(value: number): number {
        if (value === null || value === undefined || isNaN(value)) {
            return value;
        }
        return parseFloat(value.toFixed(2));
    }

    /**
     * Format value as a string with exactly 2 decimal places, matching UI display.
     * Returns empty string for null/undefined/NaN so exports show blank, not "NaN".
     */
    public static toTwoDecimalString(value: number): string {
        if (value === null || value === undefined || isNaN(value)) {
            return '';
        }
        return value.toFixed(2);
    }
}
